export const GET_INVESTMENT_INVESTMENT_DATA_ATTEMPT = 'GET_INVESTMENT_INVESTMENT_DATA_ATTEMPT';
export const GET_INVESTMENT_INVESTMENT_DATA_FAILURE = 'GET_INVESTMENT_INVESTMENT_DATA_FAILURE';
export const GET_INVESTMENT_INVESTMENT_DATA_SUCCESS = 'GET_INVESTMENT_INVESTMENT_DATA_SUCCESS';

export const CLEAR_STATE = 'CLEAR_STATE';
